import React from 'react';
import { Link } from 'react-router-dom';
import '../css/admin.css';

const AdminMenu = ({ setIsAuthenticated }) => {

    const logout = () => {
        localStorage.removeItem('isAuthenticated');
        localStorage.removeItem('authToken');
        sessionStorage.clear();
        setIsAuthenticated(false);
        window.location.replace('/LoginPage');
    };

    return (
        <nav className="admin-sidebar">
            <h3>Admin Menu</h3>

            <ul>
                <li><Link to="/admin/new">Create Blog Post</Link></li>
                <li><Link to="/admin/setlist">Setlist</Link></li>
                <li><Link to="/admin/gigs">Gigs</Link></li>
                <li><Link to="/admin/clients">Clients</Link></li>
                <li><Link to="/admin/calendar-update">Update Calendar</Link></li>
            </ul>

            <button className="logout-button" onClick={logout}>
                Log Out
            </button>
        </nav>
    );
};

export default AdminMenu;
